import React from "react";
import { IconItem } from "../Types/Configuration";
import { FaBox, FaCar } from "react-icons/fa";
import { FaDiamond } from "react-icons/fa6";
import { IoIosPricetag } from "react-icons/io";
import "./IconMenu.css";
interface IconMenuProps {
  iconMenu: IconItem[];
  isLoading: boolean;
}

const IconMenu: React.FC<IconMenuProps> = ({ iconMenu, isLoading }) => {
  const renderIcon = (iconUrl: "car" | "diamond" | "pricetag" | "box") => {
    switch (iconUrl) {
      case "car":
        const CarIcon = FaCar as any;
        return <CarIcon />;
      case "diamond":
        const DiamondIcon = FaDiamond as any;
        return (
          <>
            <DiamondIcon />
          </>
        );
      case "pricetag":
        const PricetagIcon = IoIosPricetag as any;
        return (
          <>
            <PricetagIcon />
          </>
        );
      case "box":
        const BoxIcon = FaBox as any;
        return (
          <>
            <BoxIcon />
          </>
        );
      default:
        return null;
    }
  };
  if (isLoading) {
    return <section className="icon-menu-container loading-container">
      <div className="loading"></div>
      </section>;
  }
  return (
    <section className="icon-menu-container">
      <div className="icon-menu">
      <div className="icon-menu-header">
        Miksi valita meidät?
      </div>
      <div className="icon-menu-list">
      {iconMenu.map((item, index) => (
        <div key={index} className="icon-menu-item">
          {item.iconUrl && (
            <span className="icon">{renderIcon(item.iconUrl)}</span>
          )}
            <div className="icon-menu-title">{item.title}</div>
            <div className="icon-menu-description">{item.description}</div>
          </div>
      ))}
      </div>
      </div>
    </section>
  );
};

export default IconMenu;
